export { AppInsightsConfig } from './app-insights-config.provider';
export { AppInsightsRef } from './app-insights-ref';

export { AppInsightsErrorHandler } from './app-insights-error-handler.service';
export { AppInsightsTelemetryInitializer, AppInsightsTelemtryItem, IGNORE_CANCELED_HTTP_REQUEST_AI_TELEM_INITIALIZER } from './app-insights-telem-initializers.provider';

export { AppInsightsModule } from './app-insights.module';
